module.exports = __webpack_public_path__ + "static/media/mckesson.528489de.jpg";